import { useHasUser } from '~/composables/User/useHasUser'

export default defineNuxtPlugin(() => {
  addRouteMiddleware('has-user', () => {
    if (!useHasUser()) {
      return navigateTo('/')
    }
  })
})
